import { connect } from 'react-redux';

import ExecutionOptionsBar from '../../../../../components/common/ExecutionOptionsBar';
import {
  changeAdaptive,
  toggleAverage,
  toggleMedian,
  toggleTrend,
} from '../../../../../actions/chart';
import {
  changeRetentionView,
  toggleRetentionAdaptive,
  toggleRetentionAverageLine,
  toggleRetentionMedianLine,
  toggleRetentionTrendLine,
} from '../../../../../actions/dashboards/retention';
import { getDashboardRetentionSimpleOptions } from '../../../../../reducers/analyticsApp';

const mapStateToProps = (state, { unitId }) => ({
  options: getDashboardRetentionSimpleOptions(state, unitId),
  selectStyle: { width: 200 },
  isRetention: true,
});

const mapDispatchToProps = (dispatch, { unitId }) => ({
  onChangeView: (view) => dispatch(changeRetentionView(unitId, view)),

  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleRetentionTrendLine(unitId))),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleRetentionAverageLine(unitId))),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleRetentionMedianLine(unitId))),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleRetentionAdaptive(unitId))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
